module.exports = __webpack_public_path__ + "img/7.8s.57f534a5.jpg";